module.exports = __webpack_public_path__ + "img/trunk_8x1_z18.9cc37ce0.svg";